import React from 'react';

class specialOrder extends React.Component {
    render() {
        return <div className='dms-body'>
            {this.props.children}
        </div>
    }
};
export default specialOrder;


// WEBPACK FOOTER //
// ./src/routes/specialOrder/index.js